import {
    genericPage,
    getServerSidePropsHelper,
    getMappingEleccions3CatInfo,
    getSlugEleccio,
    getBasePathEleccio
} from 'components/3catinfo/Page';
import __isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';

const basePath = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'eleccions'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, basePath);
};

export async function getServerSideProps(context) {
    const basePath = getBasePathEleccio(context?.resolvedUrl);
    const slugEleccio = getSlugEleccio(context?.resolvedUrl);
    const mapping = await getMappingEleccions3CatInfo(slugEleccio);
    if (__isEmpty(mapping)) {
        return {
            notFound: true
        };
    }

    const path = [...basePath, 'entrevistes'];
    const options = {
        slugs: path,
        id: { id: mapping.id, slug: 'entrevistes-matins' }
    };
    return getServerSidePropsHelper(context, options);
}

export default Pagina;
